import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { observable } from "mobx";

import SignaturePad from "signature_pad/dist/signature_pad.js";

import Modal from "../Modal";
import Buttons from "./Buttons";

@observer
class Signature extends React.Component {
  @observable visible = false;
  @observable isEmpty = !this.props.signature;

  __refCanvas = null;
  __signaturePad = null;

  componentDidMount() {
    this.__signaturePad = new SignaturePad(this.__refCanvas);
    this.__signaturePad.onEnd = this.handlerStopDrawing;
  }

  render() {
    const { children, title, signature } = this.props;

    return (
      <div>
        <a
          href="javascript:void(0);"
          className="signature-touch"
          onClick={this.handlerToggle}
        >
          {signature ? <img src={signature} alt="Signature Image" style={{maxWidth: '300px', maxHeight: '150px'}} /> : children}
        </a>

        <Modal
          title={title}
          visible={this.visible}
          onClose={this.handlerToggle}
        >
          <div className="signature-wrapper">
            <div className="text-center">
              <canvas ref={ref => (this.__refCanvas = ref)} />
            </div>

            <Buttons
              isEmpty={this.isEmpty}
              onClear={this.handlerClear}
              onApply={this.handlerApply}
            />
          </div>
        </Modal>
      </div>
    );
  }

  handlerToggle = () => (this.visible = !this.visible);

  handlerStopDrawing = () => {
    this.isEmpty = this.__signaturePad.isEmpty();
  };

  handlerClear = () => {
    this.__signaturePad.clear();
    this.isEmpty = true;

    this.props.onDone(null, true, this.props.signatureId);
  };

  handlerApply = () => {
    if (this.isEmpty) {
      return;
    }

    this.handlerToggle();
    this.props.onDone(this.__signaturePad.toDataURL(), false, this.props.signatureId);
  };
}

Signature.propTypes = {
  title: PropTypes.string,
  signature: PropTypes.string,
  onDone: PropTypes.func
};

Signature.defaultProps = {
  signature: null,
  title: "Signatures"
};

export default Signature;
